<template>
  <loader v-if="isLoading == true" name="spinning" loadingText="Cargando..." textColor="#ffffff" textSize="20" textWeight="500" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" :disableScrolling="true"></loader>

    <h3 v-if="existenDatosPersonaVisita == false" style="text-align: left;">Usar misma persona que en datos de la instalación</h3>
    <div class="py-3" style="text-align: left;" v-if="existenDatosPersonaVisita == false">
        <button type="button"   class="btn " style="background-color: #F49315; color: white;" @click="sinscronizarInformacion">Usar Información de datos de Instalación</button>

    </div>

   <hr>


    <h3 style="text-align: left;">Información General</h3>
    
    <div>
        <div class="py-3 col-md-12 row">
            <div class="col-md-4">
                <label for="">Nombre</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.nombre" data-toggle="tooltip" data-placement="top" title="Campo requerido" required/>
                <label class="is-invalid">{{ validation.nombre }}</label>
            </div>
            <div class="col-md-4">
                <label for="">Telefono</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.telefono" data-toggle="tooltip" data-placement="top" title="Campo requerido" required/>
                <label class="is-invalid">{{ validation.telefono }}</label>
            </div>
            <div class="col-md-4">
                <label for="">Email</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.email" data-toggle="tooltip" data-placement="top" title="Campo requerido" required/>
                <label class="is-invalid">{{ validation.email }}</label>
            </div>
            <!--<div class="col-md-4">
                <label for="">Curp</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.curp" data-toggle="tooltip" data-placement="top" title="Campo requerido" required/>
                <label class="is-invalid">{{ validation.curp }}</label>
            </div>-->

            
<div class="col-md-4">
    <label for="curp" class="form-label">
        CURP <span class="text-danger">*</span>
    </label>

    <input
        id="curp"
        name="curp"
        class="form-control"
        :class="{ 'is-invalid': validation.curp }"
        type="text"
        v-model.trim="form.curp"
        @input="form.curp = form.curp.toUpperCase()"
        maxlength="18"
        minlength="18"
        pattern="[A-Z]{4}[0-9]{6}[HM][A-Z]{5}[A-Z0-9][0-9]"
        placeholder="Ingresa tu CURP"
        title="La CURP debe tener 18 caracteres"
        autocomplete="off"
        required
    />

    <div class="is-invalid" v-if="validation.curp">
        {{ validation.curp }}
    </div>

    <small class="text-muted">
        Debe contener 18 caracteres.
    </small>
</div>

        </div>
    </div>
    <hr>
    <h3 style="text-align: left;">Domicilio</h3>
    
    
    <div >
        <div class="py-3 col-md-12 row">
            <div class="col-md-4">
                <label for="">Calle</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.calle"/>
                <label class="is-invalid">{{ validation.calle }}</label>
            </div>
            <div class="col-md-4">
                <label for="">Numero exterior</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.numero_exterior"/>
                <label class="is-invalid">{{ validation.numero_exterior }}</label>
            </div>
            <div class="col-md-4">
                <label for="">Numero interior</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.numero_interior"/>
                <label class="is-invalid">{{ validation.numero_interior }}</label>
            </div>
        </div>
        <div class="py-3 col-md-12 row">
            <div class="col-md-4">
                <label for="">Colonia</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.colonia"/>
                <label class="is-invalid">{{ validation.colonia }}</label>
            </div>
            <div class="col-md-4">
                <label for="">Codigo postal</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.codigo_postal"/>
                <label class="is-invalid">{{ validation.codigo_postal }}</label>
            </div>
            
            <div class="col-md-4">
                <label for="">Municipio</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.municipio"/>
                <label class="is-invalid">{{ validation.municipio }}</label>
            </div>
        </div>
        <div class="py-3 col-md-12 row">
            <div class="col-md-4">
                    
                <label for="estado">Estado</label><span class="is-invalid">*</span>
                <select
                    id="estado"
                    class="form-control"
                    v-model="form.estado"
                >
                    <option value="">Seleccione un estado</option>

                    <option
                        v-for="item in estados"
                        :key="item.id"
                        :value="item.nombre"
                    >
                        {{ item.nombre }}
                    </option>
                </select>
            </div>
        </div>
        <hr>
        <h3 style="text-align: left;">Documentos</h3>
        <div class="py-3 col-md-12 row">
            <div class="col-md-5">
                <label for="">Identificación Tamaño máximo 5 MB</label>
                <input type="file" @change="onFileChangeArchivo($event, 'pdfFile3')" accept="application/pdf" class="form-control"/>
            </div>
        </div><br> 
        <div v-if="identificacion"  class="col-md-5">
            <iframe  :src="identificacion" width="300" height="150" ></iframe>
        </div> 
        <div v-if="identificacion" class="col-md-5">
            <button type="button" class="btn btn-outline-warning" @click="downloadPDF(identificacion)"><i class="mdi mdi-arrow-down-bold-box" aria-hidden="true"></i>Descargar</button> &nbsp;
            <button type="button" class="btn btn-outline-danger" @click="eliminarIdentificacion()"> <i class="mdi mdi-delete-forever" aria-hidden="true"></i>  Eliminar</button>

        </div>
    </div>
    <br>
    <button type="button" v-if="existenDatosPersonaVisita == false" class="btn" style="background-color: #F49315; color: white;" @click="guardar">Guardar informacion de la persona que atiende la visita</button>
    <button type="button" v-if="existenDatosPersonaVisita == true" class="btn btn-warning" @click="actualizar">Actualizar informacion de la persona que atiende la visita</button>
    
    <br>
    </template>
    <script>
    import axios from 'axios';
    import Swal from 'sweetalert2';
    export default {
        data() {
            return {
                estados:[],
                isLoading:false,
                isButton1Disabled: false,
                isButton2Disabled: true,
                pdfFile3: null,
                identificacion: null,
                form:{
                    nombre:'',
                    telefono:'',
                    email:'',
                    curp:'',
                    calle:'',
                    numero_exterior:'',
                    numero_interior:'',
                    colonia:'',
                    codigo_postal:'',
                    municipio:'',
                    estado:'',
                    idcotizacion:"",
                    identificacion:'',
                },
                existenDatosPersonaVisita:false,
                id:'',
                validation:{
                    nombre:'',
                    telefono:'',
                    email:'',
                    calle:'',
                    numero_exterior:'',
                    numero_interior:'',
                    colonia:'',
                    codigo_postal:'',
                    municipio:'',
                    estado:'',
                    curp:'',
                }
            }  
        },
        created() {
            this.consultarRegistros();
            this.obtenerEstados();
        },
        methods: {
            async obtenerEstados() {
                try {
                    const response = await axios.get(this.$rutaServer + 'estados');
                    this.estados = response.data.data;
                } catch (error) {
                    console.error('Error al obtener los estados:', error);
                }
            },
            onFileChangeArchivo(event, campo) {
                const file = event.target.files[0];

                if (!file) {
                    return;
                }

                if (file.type !== 'application/pdf') {
                    alert('Solo se permiten archivos PDF');
                    event.target.value = '';
                    return;
                }

                if (file.size > 5 * 1024 * 1024) {
                    alert('El archivo no debe superar los 5 MB');
                    event.target.value = '';
                    return;
                }

                this[campo] = file;

                // Vista previa
                this.identificacion = URL.createObjectURL(file);
            },
            selectButton(buttonNumber) {
                if (buttonNumber === 1) {
                    this.isButton2Disabled = true;
                    this.isButton1Disabled = false;
                    document.getElementById('personaMoral').style.display = 'none';
                    document.getElementById('personaFisica').style.display = 'block';
                } else if (buttonNumber === 2) {
                    
                    this.isButton1Disabled = true;
                    this.isButton2Disabled = false;
                    document.getElementById('personaMoral').style.display = 'block';
                    document.getElementById('personaFisica').style.display = 'none';
    
    
                }
            },
            sinscronizarInformacion(){
                this.isLoading = true;
                var idcotizacion = localStorage.getItem('idcotizacion');
                
                axios.post(this.$rutaServer+'sincronizarInformacion',{idcotizacion:idcotizacion})
                .then(response => {
                   if(response.status == 200){
                    this.isLoading = false;
                        Swal.fire('¡Éxito!', 'Datos registrados', 'success');
                        this.consultarRegistros();
                   }
                    // Puedes agregar lógica adicional aquí, como mostrar un mensaje de éxito
                })
                .catch(error => {
                    console.error('Error submitting form:', error);
                    /*if(error.response.data.errors?.razon_social?.[0]){
                        this.validation.razon_social = error.response.data.errors?.razon_social?.[0];
                    }
                    if(error.response.data.errors?.nombre_representante?.[0]){
                        this.validation.nombre_representante = error.response.data.errors?.nombre_representante?.[0];
                    }
                    if(error.response.data.errors?.email?.[0]){
                        this.validation.email = error.response.data.errors?.email?.[0];
                    }
                    if(error.response.data.errors?.direccion?.[0]){
                        this.validation.direccion = error.response.data.errors?.direccion?.[0];
                    }
                    if(error.response.data.errors?.capacidad?.[0]){
                        this.validation.capacidad = error.response.data.errors?.capacidad?.[0];
                    }*/
                });
            },
            /*guardar(){
                var idcotizacion = localStorage.getItem('idcotizacion');
                this.form.idcotizacion = idcotizacion;
                axios.post(this.$rutaServer+'registrar', this.form)
                .then(response => {
                   if(response.status == 201){
                        Swal.fire('¡Éxito!', 'Datos registrados', 'success');
                        this.validation.nombre = '';
                        this.validation.email = '';
                        this.validation.telefono = '';
                        this.validation.calle = '';
                        this.validation.numero_exterior = '';
                        this.validation.numero_interior = '';
                        this.validation.colonia = '';
                        this.validation.codigo_postal = '';
                        this.validation.municipio = '';
                        this.validation.estado = '';
                        this.validation.curp = '';
                        this.consultarRegistros();
                   }
                    // Puedes agregar lógica adicional aquí, como mostrar un mensaje de éxito
                })
                .catch(error => {
                    console.error('Error submitting form:', error);
                    Swal.fire('error!', 'Todos los campos son requeridos', 'error');
                    if(error.response.data.errors?.nombre?.[0]){
                        this.validation.nombre = error.response.data.errors?.nombre?.[0];
                    }
                    if(error.response.data.errors?.email?.[0]){
                        this.validation.email = error.response.data.errors?.email?.[0];
                    }
                    if(error.response.data.errors?.telefono?.[0]){
                        this.validation.telefono = error.response.data.errors?.telefono?.[0];
                    }
                    if(error.response.data.errors?.calle?.[0]){
                        this.validation.calle = error.response.data.errors?.calle?.[0];
                    }
                    if(error.response.data.errors?.numero_exterior?.[0]){
                        this.validation.numero_exterior = error.response.data.errors?.numero_exterior?.[0];
                    }
                    if(error.response.data.errors?.numero_interior?.[0]){
                        this.validation.numero_interior = error.response.data.errors?.numero_interior?.[0];
                    }
                    if(error.response.data.errors?.colonia?.[0]){
                        this.validation.colonia = error.response.data.errors?.colonia?.[0];
                    }
                    if(error.response.data.errors?.codigo_postal?.[0]){
                        this.validation.codigo_postal = error.response.data.errors?.codigo_postal?.[0];
                    }
                    if(error.response.data.errors?.municipio?.[0]){
                        this.validation.municipio = error.response.data.errors?.municipio?.[0];
                    }
                    if(error.response.data.errors?.estado?.[0]){
                        this.validation.estado = error.response.data.errors?.estado?.[0];
                    }
                    if(error.response.data.errors?.curp?.[0]){
                        this.validation.curp = error.response.data.errors?.curp?.[0];
                    }
                    
                });
            },*/
            
            guardar() {
                var idcotizacion = localStorage.getItem('idcotizacion');
                this.form.idcotizacion = idcotizacion;

                const formData = new FormData();

                formData.append('idcotizacion', this.form.idcotizacion);
                formData.append('nombre', this.form.nombre);
                formData.append('telefono', this.form.telefono);
                formData.append('email', this.form.email);
                formData.append('calle', this.form.calle || '');
                formData.append('numero_exterior', this.form.numero_exterior || '');
                formData.append('numero_interior', this.form.numero_interior || '');
                formData.append('colonia', this.form.colonia || '');
                formData.append('codigo_postal', this.form.codigo_postal || '');
                formData.append('municipio', this.form.municipio || '');
                formData.append('estado', this.form.estado || '');
                formData.append('curp', this.form.curp || '');

                // Identificación
                if (this.pdfFile3) {
                    formData.append('identificacion', this.pdfFile3);
                }

                axios.post(
                    this.$rutaServer + 'registrar',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then(response => {

                    if (response.status == 201) {

                        Swal.fire(
                            '¡Éxito!',
                            'Datos registrados',
                            'success'
                        );

                        this.validation.nombre = '';
                        this.validation.email = '';
                        this.validation.telefono = '';
                        this.validation.calle = '';
                        this.validation.numero_exterior = '';
                        this.validation.numero_interior = '';
                        this.validation.colonia = '';
                        this.validation.codigo_postal = '';
                        this.validation.municipio = '';
                        this.validation.estado = '';
                        this.validation.curp = '';

                        // Limpiar archivo seleccionado
                        this.pdfFile3 = null;
                        this.identificacion = null;

                        this.consultarRegistros();
                    }
                })
                .catch(error => {

                    console.error('Error submitting form:', error);

                    Swal.fire(
                        'Error!',
                        'Revisa los campos requeridos',
                        'error'
                    );

                    const errors = error.response?.data?.errors || {};

                    if (errors.nombre?.[0]) {
                        this.validation.nombre = errors.nombre[0];
                    }

                    if (errors.email?.[0]) {
                        this.validation.email = errors.email[0];
                    }

                    if (errors.telefono?.[0]) {
                        this.validation.telefono = errors.telefono[0];
                    }

                    if (errors.calle?.[0]) {
                        this.validation.calle = errors.calle[0];
                    }

                    if (errors.numero_exterior?.[0]) {
                        this.validation.numero_exterior = errors.numero_exterior[0];
                    }

                    if (errors.numero_interior?.[0]) {
                        this.validation.numero_interior = errors.numero_interior[0];
                    }

                    if (errors.colonia?.[0]) {
                        this.validation.colonia = errors.colonia[0];
                    }

                    if (errors.codigo_postal?.[0]) {
                        this.validation.codigo_postal = errors.codigo_postal[0];
                    }

                    if (errors.municipio?.[0]) {
                        this.validation.municipio = errors.municipio[0];
                    }

                    if (errors.estado?.[0]) {
                        this.validation.estado = errors.estado[0];
                    }

                    if (errors.curp?.[0]) {
                        this.validation.curp = errors.curp[0];
                    }

                    if (errors.identificacion?.[0]) {
                        Swal.fire(
                            'Error!',
                            errors.identificacion[0],
                            'error'
                        );
                    }
                });
            },
            /*actualizar(){

                axios.post(this.$rutaServer+'actualizarPersonaVisita', this.form)
                .then(response => {
                   if(response.status == 200){
                        Swal.fire('¡Éxito!', 'Datos actualizados', 'success');
                        this.validation.nombre = '';
                        this.validation.email = '';
                        this.validation.telefono = '';
                        this.validation.calle = '';
                        this.validation.numero_exterior = '';
                        this.validation.numero_interior = '';
                        this.validation.colonia = '';
                        this.validation.codigo_postal = '';
                        this.validation.municipio = '';
                        this.validation.estado = '';
                        this.validation.curp = '';
                   }
                    // Puedes agregar lógica adicional aquí, como mostrar un mensaje de éxito
                })
                .catch(error => {
                    console.error('Error submitting form:', error);
                    Swal.fire('error!', 'Todos los campos son requeridos', 'error');

                    if(error.response.data.errors?.nombre?.[0]){
                        this.validation.nombre = error.response.data.errors?.nombre?.[0];
                    }
                    if(error.response.data.errors?.email?.[0]){
                        this.validation.email = error.response.data.errors?.email?.[0];
                    }
                    if(error.response.data.errors?.telefono?.[0]){
                        this.validation.telefono = error.response.data.errors?.telefono?.[0];
                    }
                    if(error.response.data.errors?.calle?.[0]){
                        this.validation.calle = error.response.data.errors?.calle?.[0];
                    }
                    if(error.response.data.errors?.numero_exterior?.[0]){
                        this.validation.numero_exterior = error.response.data.errors?.numero_exterior?.[0];
                    }
                    if(error.response.data.errors?.numero_interior?.[0]){
                        this.validation.numero_interior = error.response.data.errors?.numero_interior?.[0];
                    }
                    if(error.response.data.errors?.colonia?.[0]){
                        this.validation.colonia = error.response.data.errors?.colonia?.[0];
                    }
                    if(error.response.data.errors?.codigo_postal?.[0]){
                        this.validation.codigo_postal = error.response.data.errors?.codigo_postal?.[0];
                    }
                    if(error.response.data.errors?.municipio?.[0]){
                        this.validation.municipio = error.response.data.errors?.municipio?.[0];
                    }
                    if(error.response.data.errors?.estado?.[0]){
                        this.validation.estado = error.response.data.errors?.estado?.[0];
                    }
                    if(error.response.data.errors?.curp?.[0]){
                        this.validation.curp = error.response.data.errors?.curp?.[0];
                    }
                    
                });
            },*/
            actualizar() {
                const formData = new FormData();

                formData.append('id', this.form.id);
                formData.append('idcotizacion', this.form.idcotizacion);
                formData.append('nombre', this.form.nombre);
                formData.append('telefono', this.form.telefono);
                formData.append('email', this.form.email);
                formData.append('calle', this.form.calle);
                formData.append('numero_exterior', this.form.numero_exterior);
                formData.append('numero_interior', this.form.numero_interior);
                formData.append('colonia', this.form.colonia);
                formData.append('codigo_postal', this.form.codigo_postal);
                formData.append('municipio', this.form.municipio);
                formData.append('estado', this.form.estado);
                formData.append('curp', this.form.curp);

                // Archivo
                if (this.pdfFile3) {
                    formData.append('identificacion', this.pdfFile3);
                }

                axios.post(
                    this.$rutaServer + 'actualizarPersonaVisita',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then(response => {
                    console.log(response.data);
                    if(response.status == 200){
                        Swal.fire('¡Éxito!', 'Datos actualizados', 'success');
                        this.validation.nombre = '';
                        this.validation.email = '';
                        this.validation.telefono = '';
                        this.validation.calle = '';
                        this.validation.numero_exterior = '';
                        this.validation.numero_interior = '';
                        this.validation.colonia = '';
                        this.validation.codigo_postal = '';
                        this.validation.municipio = '';
                        this.validation.estado = '';
                        this.validation.curp = '';
                   }
                })
                .catch(error => {
                    console.log(error);
                    Swal.fire('error!', 'Todos los campos son requeridos', 'error');

                    if(error.response.data.errors?.nombre?.[0]){
                        this.validation.nombre = error.response.data.errors?.nombre?.[0];
                    }
                    if(error.response.data.errors?.email?.[0]){
                        this.validation.email = error.response.data.errors?.email?.[0];
                    }
                    if(error.response.data.errors?.telefono?.[0]){
                        this.validation.telefono = error.response.data.errors?.telefono?.[0];
                    }
                    if(error.response.data.errors?.calle?.[0]){
                        this.validation.calle = error.response.data.errors?.calle?.[0];
                    }
                    if(error.response.data.errors?.numero_exterior?.[0]){
                        this.validation.numero_exterior = error.response.data.errors?.numero_exterior?.[0];
                    }
                    if(error.response.data.errors?.numero_interior?.[0]){
                        this.validation.numero_interior = error.response.data.errors?.numero_interior?.[0];
                    }
                    if(error.response.data.errors?.colonia?.[0]){
                        this.validation.colonia = error.response.data.errors?.colonia?.[0];
                    }
                    if(error.response.data.errors?.codigo_postal?.[0]){
                        this.validation.codigo_postal = error.response.data.errors?.codigo_postal?.[0];
                    }
                    if(error.response.data.errors?.municipio?.[0]){
                        this.validation.municipio = error.response.data.errors?.municipio?.[0];
                    }
                    if(error.response.data.errors?.estado?.[0]){
                        this.validation.estado = error.response.data.errors?.estado?.[0];
                    }
                    if(error.response.data.errors?.curp?.[0]){
                        console.log(error.response.data.errors?.curp?.[0]);
                        this.validation.curp = error.response.data.errors?.curp?.[0];
                    }
                });
            },
            /*consultarRegistros(){
                this.isLoading = true;
                this.form.idcotizacion = localStorage.getItem('idcotizacion');
                axios.post(this.$rutaServer+'consultarPersonaVisita', this.form)
                .then(response => {
                   if(response.status == 200){
                    this.isLoading = false;
                        if(response.data.length > 0){
                            this.existenDatosPersonaVisita = true;
                        }
                        this.form.nombre = response.data[0].nombre;
                        this.form.email = response.data[0].email;
                        this.form.telefono = response.data[0].telefono;
                        this.form.calle = response.data[0].calle;
                        this.form.numero_exterior = response.data[0].numero_exterior;
                        this.form.numero_interior = response.data[0].numero_interior;
                        this.form.colonia = response.data[0].colonia;
                        this.form.codigo_postal = response.data[0].codigo_postal;
                        this.form.municipio = response.data[0].municipio;
                        this.form.estado = response.data[0].estado;
                        this.form.idcotizacion = response.data[0].idcotizacion;
                        this.form.id = response.data[0].id;
                        this.form.curp = response.data[0].curp;

                   }
                    // Puedes agregar lógica adicional aquí, como mostrar un mensaje de éxito
                })
                .catch(error => {
                    console.error('Error submitting form:', error);
                    
                });
            },*/
            consultarRegistros() {
                this.isLoading = true;
                this.form.idcotizacion = localStorage.getItem('idcotizacion');

                axios.post(
                    this.$rutaServer + 'consultarPersonaVisita',
                    this.form
                )
                .then(response => {

                    if (response.status == 200) {

                        this.isLoading = false;

                        if (response.data.length > 0) {

                            this.existenDatosPersonaVisita = true;

                            this.form.nombre = response.data[0].nombre;
                            this.form.email = response.data[0].email;
                            this.form.telefono = response.data[0].telefono;
                            this.form.calle = response.data[0].calle;
                            this.form.numero_exterior = response.data[0].numero_exterior;
                            this.form.numero_interior = response.data[0].numero_interior;
                            this.form.colonia = response.data[0].colonia;
                            this.form.codigo_postal = response.data[0].codigo_postal;
                            this.form.municipio = response.data[0].municipio;
                            this.form.estado = response.data[0].estado;
                            this.form.idcotizacion = response.data[0].idcotizacion;
                            this.form.id = response.data[0].id;
                            this.form.curp = response.data[0].curp;

                            // Identificación
                            if (response.data[0].identificacion) {
                                this.identificacion =
                                    this.$rutaServer.replace('/api/', '/') +
                                    'storage/' +
                                    response.data[0].identificacion;
                            } else {
                                this.identificacion = null;
                            }
                        }
                    }
                })
                .catch(error => {
                    console.error('Error submitting form:', error);
                    this.isLoading = false;
                });
            },
            downloadPDF(descargar) {
                
                const pdfUrl = descargar;
                // Abrir el PDF en una nueva pestaña
                window.open(pdfUrl, '_blank');
            },
            
async eliminarIdentificacion() {

    const token = localStorage.getItem('accessToken');

    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json'
        }
    };

    const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'Se eliminará la identificación.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {

        axios.post(
            this.$rutaServer + 'eliminarIdentificacion',
            {
                id: this.form.id
            },
            config
        )
        .then(response => {

            if (response.status == 200) {

                this.identificacion = null;
                this.pdfFile3 = null;

                Swal.fire(
                    '¡Éxito!',
                    'Identificación eliminada',
                    'success'
                );
            }

        })
        .catch(error => {

            console.error(error);

            Swal.fire(
                '¡Error!',
                'Ocurrió un error al eliminar la identificación',
                'error'
            );
        });
    }
}


        },
            
    };
    </script>